var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGasMeter(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 20,
    viewBox: "0 0 16 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 20C2.9 20 1.95833 19.6083 1.175 18.825C0.391667 18.0417 0 17.1 0 16V6C0 4.9 0.391667 3.95833 1.175 3.175C1.95833 2.39167 2.9 2 4 2H5V0H7V2H9V0H11V2H12C13.1 2 14.0417 2.39167 14.825 3.175C15.6083 3.95833 16 4.9 16 6V16C16 17.1 15.6083 18.0417 14.825 18.825C14.0417 19.6083 13.1 20 12 20H4ZM4 8H12V6H4V8ZM8 16C8.7 16 9.29167 15.7625 9.775 15.2875C10.2583 14.8125 10.5 14.2333 10.5 13.55C10.5 13 10.3417 12.5292 10.025 12.1375C9.70833 11.7458 9.03333 10.95 8 9.75C6.95 10.95 6.27083 11.75 5.9625 12.15C5.65417 12.55 5.5 13.0167 5.5 13.55C5.5 14.2333 5.74167 14.8125 6.225 15.2875C6.70833 15.7625 7.3 16 8 16Z",
    fill: "#71717A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGasMeter);
export default __webpack_public_path__ + "static/media/gas_meter.17a8008239b8edba97d4ff2e4108d3a9.svg";
export { ForwardRef as ReactComponent };